import {
    useToggleArchivePriceTypeMutation,
    useCreatePriceTypeMutation,
    useGetArchivedPaginatedPriceTypesMutation,
    useGetPaginatedPriceTypesMutation,
    useUpdatePriceTypeMutation
} from '@services/member/list/price-types/price-types.endpoints';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { PriceType } from '@services/member/list/price-types/price-types.types';

export const useApartmentPricesPageVM = () => {
    const [totalPriceTypes, setTotalPriceTypes] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updatePriceType,
        {
            isSuccess: isUpdatePriceTypeSuccess
        }
    ] = useUpdatePriceTypeMutation();


    const [
        createPriceType,
        {
            isSuccess: isCreatePriceTypeSuccess
        }
    ] = useCreatePriceTypeMutation();

    const [
        toggleArchivePriceType,
        {
            isSuccess: isToggleArchivePriceTypeSuccess
        }
    ] = useToggleArchivePriceTypeMutation();

    const handleArchivePriceTypes = async (lines: PriceType[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce type de prix d\'appartement ?' : 'Êtes-vous sûr de vouloir désarchiver ce type de prix d\'appartement ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces types de prix d\'appartement ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de prix d\'appartement ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchivePriceType({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreatePriceTypeSuccess || isUpdatePriceTypeSuccess || isToggleArchivePriceTypeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreatePriceTypeSuccess, isUpdatePriceTypeSuccess, isToggleArchivePriceTypeSuccess]);

    useEffect(() => {
        setTotalPriceTypes(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalPriceTypes(metadata.total);
        }
    };

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedPriceTypesMutation : useGetPaginatedPriceTypesMutation;
    }, [isArchived]);

    return {
        mutationHook,
        totalPriceTypes,
        setTotalPriceTypes,
        isArchived,
        handleMetadata,
        needReload,
        setIsArchived,
        createPriceType,
        updatePriceType,
        handleArchivePriceTypes,
        MySwal
    };
};
